<template>
  <div>
    <myHeader />
    <!-- 订阅部分 -->
    <div class="bg">
      <h1>SOFTWARE SUBSCRIPTION</h1>
      <div class="card-container">
        <div @click="selectCard(index)" v-for="(card, index) in cards" :key="index" class="card" :style="{
          border: card.isSelected ? '4px solid #2a82e4' : '0px solid #2a82e4',
          boxShadow: card.isSelected ? '5px 5px 20px #007bff' : 'none',
        }">
<!--          <div class="card-header">{{ card.title }}</div>-->
          <div class="card-icon" :style="{ backgroundColor: card.bgColor }">
<!--            <img :src="card.imgsrc1" alt="" />-->
            {{ card.title }}
          </div>
          <div class="card-price">
            <span>{{ card.price }}</span>
          </div>
        </div>
      </div>
      <div class="feedback-container">
        <p>
          Please enter the name of the staff member who satisfies you the most, as this will help generate positive motivation for them and enhance your learning and usage experience.
        </p>

        <div class="input-group">
          <p>name:&nbsp;&nbsp;&nbsp;&nbsp;<input type="text" v-model="workName" placeholder="Staff name (optional)" />
          </p>
          <p>number:<input @input="validateInput" type="number" v-model="selectedNum"
              placeholder="Please enter the quantity" /></p>
          <p><button :disabled="btnDisabled" @click="handleSubscribe">Subscribe Now</button></p>
        </div>
      </div>
    </div>

    <!-- 轮播图部分 -->
    <div class="bg1">
      <div>
        <h1 class="headtext">
          LOG IN TO YOUR HECOOS ACCOUNT TO UNLOCK EXCLUSIVE EXPERIENCE
        </h1>
      </div>

      <!-- vant轮播 -->
      <div class="swipe-container">
        <van-swipe :autoplay="5000" :circular="true" ref="mySwipe" :show-indicators="false">
          <van-swipe-item v-for="(image, index) in slides" :key="index">
            <img :src="image.image" alt="轮播图图片" />
            <p class="image-desc">{{ image.desc }}</p>
          </van-swipe-item>
        </van-swipe>

        <!-- 下方切换按钮 -->
        <div class="arrow-wrapper">
          <div class="arrow-left" @click="prev">
            <button class="prev-button">&#60;</button>

          </div>
          <div class="arrow-right" @click="next">
            <button class="next-button">&#62;</button>
          </div>
        </div>
      </div>
    </div>
    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import myTest from "@/components/en_mobile/myTest.vue";
import { paypal } from "@/api/api";
import { Message } from "element-ui";
export default {
  components: { myHeader, myFooter, myTest },
  data() {
    return {
      btnDisabled: false,
      cards: [
        {
          title: "Weekly",
          imgsrc1: require("@/asset/SoftwareSubscriptions/week.svg"),
          iconClass: "fa-solid fa-bicycle",
          price: "$12.00",
          subtext: "Per week",
          btnClass: "",
          bgColor: "#848A95 ",
          orderType: 3,
          isSelected: true,
          num: 1,
        },
        {
          title: "Monthly",
          imgsrc1: require("@/asset/SoftwareSubscriptions/mouth.svg"),
          iconClass: "fa-solid fa-car",
          price: "$29.00",
          subtext: "Per month",
          btnClass: "active",
          bgColor: "#147CF5",
          orderType: 1,
          isSelected: false,
          num: 1,
        },
        {
          imgsrc1: require("@/asset/SoftwareSubscriptions/year.svg"),
          title: "Yearly",
          iconClass: "fa-solid fa-rocket",
          price: "$299.00",
          subtext: "Per year",
          btnClass: "dark",
          bgColor: "#0B162B",
          orderType: 2,
          isSelected: false,
          num: 1,
        },
      ],

      currentIndex: 0,
      workName: '',
      orderType: null,  //存储对应的 周月年
      staffName: '',   //存储姓名
      selectedNum: 1,  // 新增变量，用于存储选中卡片的数量
      slides: [
        {
          image:
              "https://download.hecoos.com/enlightv/2025-37/28b0215286c7d1e1c1907b0a918d8b81.png",
          desc: "3D Pre-Visualization, Projection Simulation, Lighting Effects Editing, and Director Design.",
        },
        {
          image:
              "https://download.hecoos.com/enlightv/2025-37/5b9aa1b57aec71f2b1b8d35047e0ce57.png",
          desc: "2*2K Test Signal Output (Watermarked), External Equipment Control (Intermittent Interruptions).",
        },
        {
          image:
              "https://download.hecoos.com/enlightv/2025-17/9c609c133d5ff2e733e08934ef8167c5.png",
          desc: "Program and Control Command Editing, Onsite Project Debugging.",
        },
        {
          image:
              "https://download.hecoos.com/enlightv/2025-35/02a5e47e63883b0428b059fb2ae7357b.jpg",
          desc: "As a project testing application, it can be used independently of the hecoos server",
        },
      ],
    };
  },
  created() {
    // this.MembershipSubscription()
    if (localStorage.getItem('orderMsg')) {
      const msg = JSON.parse(localStorage.getItem('orderMsg'));
      this.cards.forEach((item, index) => {
        if (item.orderType == msg.orderType) {
          this.orderType = msg.orderType;
          item.isSelected = true;
          item.num = msg.num;
        } else {
          item.isSelected = false;
        }
      })
      // 重新选中年月日
      // if (msg.orderType === 3) {
      //   this.cards[0].isSelected = true;
      //   this.cards[0].num = msg.num;
      // } else if (msg.orderType === 1) {
      //   this.cards[1].isSelected = true;
      //   this.cards[1].num = msg.num;
      // } else if (index === 2) {
      //   this.cards[2].isSelected = true;
      //   this.cards[2].num = msg.num;
      // }
      // 重新赋值之前选择的数量
      this.selectedNum = msg.num
      localStorage.removeItem('orderMsg');
    }
  },
  methods: {
    validateInput() {
      // 移除所有非数字字符
      let value = this.selectedNum.toString().replace(/[^0-9]/g, '');

      // 转换为数字
      let num = Number(value);

      // 处理空值情况
      if (value === '') {
        this.selectedNum = '';
        return;
      }

      // 限制范围
      if (num < 1) {
        num = 1;
      } else if (num > 99) {
        num = 99;
      }

      this.selectedNum = num;
    },

    prev() {
      this.$refs.mySwipe.prev();
    },
    next() {
      this.$refs.mySwipe.next();
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },

    // 选中对应的价格
    selectCard(index) {
      this.cards.forEach((card, i) => {
        card.isSelected = i === index;
      });
      // 存储对应的数字 1, 2, 3
      if (index === 0) {
        this.orderType = 3;
      } else if (index === 1) {
        this.orderType = 1;
      } else if (index === 2) {
        this.orderType = 2;
      }
      console.log(this.orderType)
      this.selectedNum = this.cards[index].num; // 更新选中卡片的数量
      // console.log(this.selectedNum);
    },

    handleSubscribe() {
      const orderMsg = {
        orderType: this.orderType,
        num: this.selectedNum,
      }
      if (!this.orderType) {
        Message.error('Please select the subscription type first');
        return;
      }
      if (this.selectedNum <= 0) {
        Message.error('The subscription quantity must be greater than 0');
        return;
      }
      if (!localStorage.getItem('token')) {
        localStorage.setItem('orderMsg', JSON.stringify(orderMsg))
        Message.error('please log in first')
        setTimeout(() => {
          this.$router.push('/en/login')
        }, 800)
        return
      }

      const type = this.orderType;
      const num = this.selectedNum;
      this.MembershipSubscription(type, num);
    },

    MembershipSubscription(type, num) {

      let postData = {
        orderType: type,
        num: num,
        // staffName: this.staffName  //姓名不传
      };
      paypal(postData).then((res) => {
        this.btnDisabled = true
        if (res.status == 0) {
          if (res.data) {
            this.btnDisabled = false
            window.location.href = res.data;
          }
        } else {
          this.$message.error(res.message)
          if(res.message == 'Login information has expired, please log in again.'){
            this.$router.push("/en/login");
          }
          this.btnDisabled = false
        }

      })
      // console.log(postData);

      // VipSubscribe(postData).then((res) => {
      //   if (res.code === 200) {
      //     // 创建一个新的 div 元素来插入表单
      //     const formDiv = document.createElement("div");
      //     formDiv.innerHTML = res.data.buyFormHtml;
      //     console.log(res.data)
      //     document.body.appendChild(formDiv);
      //     // 自动提交表单
      //     const form = formDiv.querySelector("form");
      //     if (form) {
      //       form.submit();
      //     }
      //   } else {
      //     console.error("Subscription failed:", res.message);
      //   }
      // });
    },
  },
};
</script>

<style scoped>
.swipe-container {
  position: relative;

}

.swipe-container img {
  width: 100%;
}

.prev-button,
.next-button {
  padding: 8px 12px;
  background-color: #1B1818;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s ease;
}

.prev-button:active,
.next-button:active {
  background-color: #343334;
}

.arrow-wrapper {


  display: flex;
  justify-content: right;
  padding: 20px 0;
}

.arrow-left,
.arrow-right {
  cursor: pointer;
  margin-right: 10px;
  /* 按钮之间添加间距 */
  /* 可进一步设置箭头的样式，如颜色、大小等 */
}

.bg {
  background: black;
}

.bg h1 {
  font-size: 26px;
  text-align: center;
  color: white;
  padding: 35px 43px;
}

.card-container {
  padding: 0px 43px;
}

.card {
  background-color: #fff;
  border-radius: 5px;
  padding:12px 5px;
  text-align: center;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  margin: 30px 0;
}

.card:nth-child(1) {
  margin: 0px 0px 0 0;
}

.card-header {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 48px;
  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-icon {
  /*width: 40px;*/
  /*height: 40px;*/
  /*border-radius: 50%;*/
  /*margin: 0 auto 20px;*/

  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: #007bff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  margin:18px auto 30px auto;
}

.card-icon img {
  width: 25px;
  height: 25px;
  position: relative;
  top: 5px;
}

.card-icon i {
  font-size: 20px;
}

.card-price {
  font-size: 20px;
  font-weight: 400;

  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-price span:last-child {
  font-size: 20px;
}

.card-subtext {
  color: #777;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;

  text-align: center;
  vertical-align: top;
}

.subscribe-btn {
  padding: 5px 30px;
  border: 1px solid #ccc;
  border-radius: 20px;
  background-color: white;
  cursor: pointer;
  text-align: center;
  margin: 25px 0;
}

.subscribe-btn:hover {
  color: white;
  background-color: #ccc;
}

.active {
  background-color: #147cf5;
  color: white;
  border-color: #147cf5;
}

.active:hover {
  background-color: white;
  color: #007bff;
}

.dark {
  background-color: #333;
  color: white;
  border-color: #333;
}

.dark:hover {
  color: #333;
  background-color: white;
}

.feedback-container {
  font-family: YourFontName2;
  padding: 10px 43px;
}

.feedback-container p {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 20px;
  vertical-align: top;
  font-family: YourFontName2;
}

.kk {
  color: #147cf5;
  border: 1px solid gray;
  width: 50px;
  height: 30px;
  text-align: left;
  margin: 0;
  background-color: #e5e5e5;
  color: black;
  border-radius: 10px;
  padding: 0px 50px 0px 10px;
  vertical-align: middle;
}

.input-group {
  margin-top: 20px;
}

.input-group input {
  padding: 5px 0px 5px 10px;
  color: white;
  background-color: #333333;
  border-radius: 2px 0px 0px 2px;
  border: none;
  border-radius: 2px;
  color: gray;
  margin: 10px 5px;
}

.input-group button {
  padding: 5px 15px 5px 15px;
  background-color: #147cf5;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 12px;
  width: 200px;
  margin: 10px 0;
}

.input-group button:hover {
  color: #147cf5;
  background-color: white;
}

.login-container {
  text-align: center;
  color: white;
  background-color: black;
  padding: 100px 0;
  width: 80%;
  margin: 0 auto;
}

.bg1 {
  background-color: black;
  padding: 0px 43px;
}

.headbanner h1 {
  font-size: 50px;
  text-align: center;
  color: white;
  padding: 200px 0px 0px 0px;
}

.headbanner p {
  font-size: 16px;
  text-align: center;
  color: white;
  padding: 50px 0px 100px 0px;
}

.headbanner {
  text-align: center;
}

.slider {
  overflow: hidden;
}

.slider-wrapper {
  display: flex;

  transition: transform 1s ease;
}

.slide p {
  color: gray;
  font-size: 15px;
  font-family: YourFontName2;
  text-align: left;
  padding: 20px 0;
}

.slide img {
  width: auto;
  object-fit: cover;
}

.headtext {
  color: white;
  font-size: 26px;
  text-align: center;
  vertical-align: top;
  padding: 30px 0;
}

.headtext span {
  background: linear-gradient(to left,
      rgba(76, 142, 212, 1),
      rgba(128, 99, 220, 1),
      rgba(173, 63, 226, 1));
  /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
  background-clip: text;
  /*将设置的背景颜色限制在文字中*/
  -webkit-text-fill-color: transparent;
  /*给文字设置成透明*/
}

.colorb {
  color: #6600ff;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 15px;
  border-radius: 50%;
}

.image-desc {
  padding-top: 15px;
  color: #85858A;
}

.arrow-button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: #343334;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
  transition: all 0.5s ease;
}

.arrow-button:hover {
  background-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.parents {
  text-align: right;
  height: 50px;
}
@media screen and (min-width: 768px){
  .swipe-container {
  position: relative;

}

.swipe-container img {
  width: 100%;

}

.prev-button,
.next-button {
  padding: 8px 12px;
  background-color: #1B1818;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  transition: background-color 0.3s ease;
}

.prev-button:active,
.next-button:active {
  background-color: #343334;
}

.arrow-wrapper {
  display: flex;
  justify-content: right;
  padding: 20px 0;
}

.arrow-left,
.arrow-right {
  cursor: pointer;
  margin-right: 10px;
  /* 按钮之间添加间距 */
  /* 可进一步设置箭头的样式，如颜色、大小等 */
}

.bg {
  background: black;
}

.bg h1 {
  font-size: 50px;
  text-align: center;
  color: white;
  padding: 35px 43px;
}

.card-container {
  padding: 0px 43px;
}

.card {
  background-color: #fff;
  border-radius: 5px;
  padding:12px 5px;
  text-align: center;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  margin: 30px 0;
}

.card:nth-child(1) {
  margin: 0px 0px 0 0;
}

.card-header {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 48px;
  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-icon {
  /*width: 40px;*/
  /*height: 40px;*/
  /*border-radius: 50%;*/
  /*margin: 0 auto 20px;*/

  width: 84px !important;
  height: 84px !important;
  border-radius: 50%;
  background-color: #007bff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  margin:18px auto 30px auto;
}

.card-icon img {
  width: 25px;
  height: 25px;
  position: relative;
  top: 5px;
}

.card-icon i {
  font-size: 20px;
}

.card-price {
  font-size: 26px;
  font-weight: 400;

  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-price span:last-child {
  font-size: 26px;
}

.card-subtext {
  color: #777;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;
  text-align: center;
  vertical-align: top;
}

.subscribe-btn {
  padding: 5px 30px;
  border: 1px solid #ccc;
  border-radius: 20px;
  background-color: white;
  cursor: pointer;
  text-align: center;
  margin: 25px 0;
}

.subscribe-btn:hover {
  color: white;
  background-color: #ccc;
}

.active {
  background-color: #147cf5;
  color: white;
  border-color: #147cf5;
}

.active:hover {
  background-color: white;
  color: #007bff;
}

.dark {
  background-color: #333;
  color: white;
  border-color: #333;
}

.dark:hover {
  color: #333;
  background-color: white;
}

.feedback-container {
  font-family: YourFontName2;
  padding: 10px 43px;
}

.feedback-container p {
  font-size: 20px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 21px;
  vertical-align: top;
  font-family: YourFontName2;
}

.kk {
  color: #147cf5;
  border: 1px solid gray;
  width: 50px;
  height: 30px;
  text-align: left;
  margin: 0;
  background-color: #e5e5e5;
  color: black;
  border-radius: 10px;
  padding: 0px 50px 0px 10px;
  vertical-align: middle;
}

.input-group {
  margin-top: 20px;
}

.input-group input {
  padding: 5px 45px 5px 10px;
  color: white;
  background-color: #333333;
  border-radius: 2px 0px 0px 2px;
  border: none;
  border-radius: 2px;
  color: gray;
  margin: 10px 5px;
}

.input-group button {
  padding: 5px 15px 5px 15px;
  background-color: #147cf5;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 30px;
  width: 350px;
  height: 50px;
  margin: 10px 0;
}

.input-group button:hover {
  color: #147cf5;
  background-color: white;
}

.login-container {
  text-align: center;
  color: white;
  background-color: black;
  padding: 100px 0;
  width: 80%;
  margin: 0 auto;
}

.bg1 {
  background-color: black;
  padding: 0px 43px;
}

.headbanner h1 {
  font-size: 50px;
  text-align: center;
  color: white;
  padding: 200px 0px 0px 0px;
}

.headbanner p {
  font-size: 16px;
  text-align: center;
  color: white;
  padding: 50px 0px 100px 0px;
}

.headbanner {
  text-align: center;
}

.slider {
  overflow: hidden;
}

.slider-wrapper {
  display: flex;

  transition: transform 1s ease;
}

.slide p {
  color: gray;
  font-size: 15px;
  font-family: YourFontName2;
  text-align: left;
  padding: 20px 0;
}

.slide img {
  width: auto;
  object-fit: cover;
}

.headtext {
  color: white;
  font-size: 40px;
  text-align: center;
  vertical-align: top;
  padding: 30px 0;
}

.headtext span {
  background: linear-gradient(to left,
      rgba(76, 142, 212, 1),
      rgba(128, 99, 220, 1),
      rgba(173, 63, 226, 1));
  /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
  background-clip: text;
  /*将设置的背景颜色限制在文字中*/
  -webkit-text-fill-color: transparent;
  /*给文字设置成透明*/
}

.colorb {
  color: #6600ff;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 15px;
  border-radius: 50%;
}

.image-desc {
  padding-top: 15px;
  color: #85858A;
  font-size: 20px !important;
}

.arrow-button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: #343334;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
  transition: all 0.5s ease;
}

.arrow-button:hover {
  background-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.parents {
  text-align: right;
  height: 50px;
}
}
</style>
